import { useEffect, useMemo, useState, useContext } from 'react';
import { Context } from '../../../context/UserContext';

import { useNavigateParams } from '../../../hooks/useNavigateParams';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useMRTState } from '../../../hooks/useMRTState';
import { podeImprimir, podeIncluir, podeEditar, podeCancelar, podeImprimirGerencia } from '../../../hooks/usePermisionMRT';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import ResponsiveToolbarActions from '../../layout/ResponsiveToolbarActions';
import CustomDialog from '../../layout/CustomDialog';

import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit, Print } from '@mui/icons-material';
import tratar from '../../../utils/retornaTratamentoURL';
import CrudsAPI from '../../../api/CRUDs';

/* util */
import { obterPermissoesUsuario, printPdf } from '../../../utils/funcoes';
import * as SituacaoAPI from '../../../api/situacao';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { resolveEmpresaTabela } from '../../../utils/funcoes';
import { retornaDataBr } from '../../../utils/retornaDataFormatada';

const Index = () => {
    const [dados, setDados] = useState([]);
    const [token] = useState(localStorage.getItem('token')) || '';
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    // escopo empresa
    const { parametro } = useContext(Context);
    const { pessoaId, empresaId } = getEmpresaScope();
    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);

    const pathname = '/Homologation/CreateOrEdit';
    const ul = urlParams.get('ul') || 12;
    const li = urlParams.get('li') || 103;
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || 'Cadastrar';

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    /* Obtem a paginação padrão */
    useEffect(() => {
        if (parametro && parametro.paginacao) {
            setPagination({
                pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
                pageSize: JSON.parse(localStorage.pagination).pageSize || parametro.paginacao,
            });
        }
    }, [parametro]);

    //Enums / options
    const [situacaoMap, setMapSituacao] = useState([]);

    const consultaSituacao = async (tabela) => {
        try {
            const result = await SituacaoAPI.situacoes(empresaTabelaId);

            if (tabela === 'homologation') {
                const filtrado = result?.filter((item) => item.homologation === true) || [];

                const mappedResult = filtrado.map((item) => ({
                    text: item.descricao,
                    value: item.descricao,
                }));
                setMapSituacao(mappedResult);
            }
        } catch (error) {
            console.error(error);
        }
    };

    //dialog customizado
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    //tratar filtros se vier pela navbar
    if (localStorage.path.replace(/["]/g, '') !== window.location.pathname) {
        tratar.LimparFiltros();
        localStorage.setItem('path', JSON.stringify(window.location.pathname));
    }

    //table state
    const {
        columnFilterFns,
        setColumnFilterFnsMode: setColumnFiltersMode, // mantém o nome que você já usa
        columnFilters,
        setColumnFilters,
        globalFilter,
        setGlobalFilter,
        sorting,
        setSorting,
        pagination,
        setPagination,
        // estado da requisição
        isError,
        setIsError,

        isLoading,
        setIsLoading,

        isRefetching,
        setIsRefetching,

        // server side row count
        rowCount,
        setRowCount,
    } = useMRTState({
        storageKey: 'movimento.mrt', // pode mudar depois
        pageSizeDefault: parametro?.paginacao,
    });

    const fetchData = async () => {
        if (!dados.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }

        try {
            const { data } = await CrudsAPI.homologation.listar(
                pagination.pageIndex * pagination.pageSize,
                pagination.pageSize,
                JSON.stringify(columnFilters ?? []),
                JSON.stringify(columnFilterFns ?? []),
                globalFilter ?? '',
                JSON.stringify(sorting ?? [])
            );
            setDados(data.data);
            setRowCount(data.meta.totalRowCount);
        } catch (error) {
            setIsError(true);
            console.error(error);
            return;
        }
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };

    //funções do dialog
    const handleOpenDialog = (row) => {
        setOpenDialog(true);
        setSelectedRow(row);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDialog = async () => {
        // Verifique se há uma linha selecionada
        let msgType = 'success';
        if (selectedRow) {
            // Lógica de confirmação
            try {
                const { data } = await CrudsAPI.homologation.deletar(selectedRow);
                setFlashMessage(data.message, msgType);

                // Após a exclusão, chame a função fetchData() novamente para atualizar as unidades
                fetchData();
            } catch (error) {
                msgType = 'error';
                console.error(error);
                setFlashMessage(error.response.data.message, msgType);
            }
        }
        setOpenDialog(false);
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        //funcao para setar localStorage
        localStorage.setItem(
            'pagination',
            JSON.stringify({
                pageIndex: pagination.pageIndex,
                pageSize: pagination.pageSize,
            })
        );
        localStorage.setItem('columnFilterFns', JSON.stringify(columnFilterFns));
        localStorage.setItem('columnFilters', JSON.stringify(columnFilters));
        localStorage.setItem('globalFilter', JSON.stringify(globalFilter));
        localStorage.setItem('sorting', JSON.stringify(sorting));

        //permissões do usuario
        obterPermissoesUsuario(pessoaId, empresaId, ul, li);

        consultaSituacao('homologation');

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, columnFilterFns, columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting]);

    const columns = useMemo(
        () => [
            {
                id: 'Homologation',
                header: 'Homologações das rotinas do sistema',
                columns: [
                    {
                        accessorKey: 'contador',
                        header: 'Número',
                    },
                    {
                        accessorKey: 'descricao',
                        header: 'Descrição',
                        muiTableBodyCellProps: ({ row }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'Situacao.descricao',
                        header: 'Situação',
                        columnFilterModeOptions: ['fuzzy', 'equals', 'notEquals'],
                        filterVariant: 'select',
                        filterSelectOptions: situacaoMap,
                    },
                    {
                        accessorKey: 'data',
                        header: 'Data',
                        Cell: ({ cell }) => (cell.getValue() ? retornaDataBr(cell.getValue(), 'date') : ''),
                    },
                    {
                        accessorKey: 'dataInicio',
                        header: 'Início',
                        Cell: ({ cell }) => (cell.getValue() ? retornaDataBr(cell.getValue(), 'date') : ''),
                    },
                    {
                        accessorKey: 'dataFim',
                        header: 'Fim',
                        Cell: ({ cell }) => (cell.getValue() ? retornaDataBr(cell.getValue(), 'date') : ''),
                    },
                ],
            },

            //column definitions...
        ],
        [situacaoMap] //getCommonEditTextFieldProps
    );

    /* modo tema */
    const theme = tableThemeCustom();

    //função do toolbar
    // Handlers específicos da tela
    const handleNovo = () => {
        params.delete('uuid');
        params.set('btnText', 'Cadastrar');
        navigate(pathname, params);
    };

    return (
        <div>
            <div>
                {openDialog && (
                    <CustomDialog
                        title="Delete Homologação!"
                        content="Você tem certeza?"
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                    />
                )}
            </div>
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: {
                                align: 'center',
                            },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true, //turn on some features that are usually off
                            enableResizing: true,
                            muiTableHeadCellProps: {
                                sx: {
                                    fontSize: '1.2rem',
                                },
                            },
                        },
                        'mrt-row-select': {
                            enableColumnActions: true,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    //enableColumnResizing
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row, table }) => {
                        const handleImprimir = async (obj) => {
                            const response = await CrudsAPI.homologation.imprimir({}, obj);
                            printPdf(response.data);
                        };
                        return (
                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                <Tooltip arrow placement="top" title="Editar">
                                    <span>
                                        {' '}
                                        <IconButton
                                            onClick={() => {
                                                params.set('uuid', row.id);
                                                params.set('btnText', 'Atualizar');
                                                navigate(pathname, params);
                                            }}
                                            disabled={!podeEditar()}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow placement="bottom" title="Deletar">
                                    <span>
                                        <IconButton
                                            color="error"
                                            onClick={() => handleOpenDialog(row)}
                                            disabled={!podeCancelar()}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow placement="right" title="Imprimir">
                                    <span>
                                        {' '}
                                        <IconButton
                                            onClick={() => handleImprimir(row.original)}
                                            disabled={!podeImprimirGerencia()}
                                        >
                                            <Print />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Box>
                        );
                    }}
                    renderTopToolbarCustomActions={({ table }) => {
                        const actions = [
                            {
                                key: 'novo',
                                label: 'Novo',
                                tooltip: 'Novo Registro',
                                color: 'secondary',
                                onClick: handleNovo,
                                disabled: !podeIncluir(),
                            },
                        ].filter((a) => a?.show ?? true);
                        return <ResponsiveToolbarActions actions={actions} />;
                    }}
                    columns={columns}
                    data={dados}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                        isError
                            ? {
                                  color: 'error',
                                  children: 'Error loading data',
                              }
                            : undefined
                    }
                    onColumnFiltersChange={setColumnFilters}
                    onColumnFilterFnsChange={setColumnFiltersMode}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={rowCount}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                        //columnPinning: { left: ["mrt-row-select"] },
                    }}
                    state={{
                        columnFilterFns,
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                    }}
                    //positionToolbarDropZone={"top"}
                    positionExpandColumn={'first'}
                    positionActionsColumn={'first'}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};
export default Index;
